export default __webpack_public_path__ + "static/louis-pembroke-welsh-corgi-44301e4f3cd58aef98903dd801fed5d9.jpg";